import React, { useState, useEffect } from 'react';

import PhotoCapture from '../PhotoCapture';
import UserInfoForm from '../UserInfoForm';
import ConditionPage from '../ConditionPage';
import UnifiedDoctorAnalysis from './UnifiedDoctorAnalysis';

const CameraIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" style={{ color }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const SparklesIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" style={{ color }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
  </svg>
);

const DocumentTextIcon = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" style={{ color }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const PhoneIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);

const WhatsAppIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.894 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 4.315 1.919 6.066l-1.285 4.685 4.849-1.282z" />
  </svg>
);

const MapPinIcon = ({ className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} style={style} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const CalendarIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

const UserCircleIcon = ({ className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} style={style} viewBox="0 0 20 20" fill="currentColor">
    <path
      fillRule="evenodd"
      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
      clipRule="evenodd"
    />
  </svg>
);

const BuildingIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
  </svg>
);

const UnifiedDoctorPage = ({ config }) => {
  const [currentStep, setCurrentStep] = useState('welcome');
  const [capturedImage, setCapturedImage] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [analysisData, setAnalysisData] = useState(null);

  const doctorInfo = config;

  const renderStep = () => {
    switch (currentStep) {
      case 'welcome':
        return config.welcomeStyle === 'minimal' ? <MinimalWelcomeScreen config={config} onStart={() => setCurrentStep('capture')} /> : <SplitPaneWelcomeScreen config={config} onStart={() => setCurrentStep('capture')} />;
      case 'capture':
        return (
          <PhotoCapture
            nextStep={() => setCurrentStep('userinfo')}
            updateCapturedImage={setCapturedImage}
            appState={{ capturedImage, patientData: userInfo, analysisResult: analysisData }}
            setError={() => {}}
          />
        );
      case 'userinfo':
        return (
          <UserInfoForm
            nextStep={() => setCurrentStep('conditions')}
            previousStep={() => setCurrentStep('capture')}
            updatePatientData={setUserInfo}
            appState={{ capturedImage, patientData: userInfo, analysisResult: analysisData }}
            setError={() => {}}
          />
        );
      case 'conditions':
        return (
          <ConditionPage
            nextStep={() => setCurrentStep('analysis')}
            previousStep={() => setCurrentStep('userinfo')}
            updatePatientData={data => setUserInfo(prev => ({ ...prev, ...data }))}
            appState={{ capturedImage, patientData: userInfo, analysisResult: analysisData }}
            setError={() => {}}
          />
        );
      case 'analysis':
      case 'pdf':
        return (
          <UnifiedDoctorAnalysis
            nextStep={() => setCurrentStep('pdf')}
            previousStep={() => setCurrentStep('conditions')}
            updateAnalysisResult={setAnalysisData}
            appState={{ capturedImage, patientData: userInfo, analysisResult: analysisData }}
            setError={() => {}}
            doctorInfo={doctorInfo}
            config={config}
          />
        );
      default:
        return <div>Unknown step</div>;
    }
  };

  return <div className="font-sans">{renderStep()}</div>;
};

const FetchedImage = ({ src, alt, config }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [hasError, setHasError] = useState(false);

  const sizeClass = config.photoSize === 'large' ? 'w-56 h-56 mb-6' : config.photoSize === 'medium' ? 'w-40 h-40 mb-5' : 'w-28 h-28 mb-4';
  const iconSizeClass = config.photoSize === 'large' ? 'w-32 h-32' : config.photoSize === 'medium' ? 'w-24 h-24' : 'w-20 h-20';
  const hasCustomPhotoRing = config.photoRingStyle === 'double-accent';
  const photoRingOuterStart = config.photoRingOuterStart || config.accentColor;
  const photoRingOuterEnd = config.photoRingOuterEnd || config.accentColorDark || config.accentColor;
  const photoRingInner = config.photoRingInner || '#FFFFFF';
  const photoRingShadow = config.photoRingShadow || `${config.accentColor}33`;
  const photoImageStyle = {
    objectPosition: config.photoObjectPosition || undefined,
    transform: typeof config.photoZoom === 'number' ? `scale(${config.photoZoom})` : undefined,
    transformOrigin: config.photoTransformOrigin || 'center center'
  };

  useEffect(() => {
    let isCancelled = false;

    const fetchImage = async () => {
      if (!src) {
        setHasError(true);
        return;
      }

      if (src.startsWith('/') || src.startsWith('data:image')) {
        if (!isCancelled) setImageUrl(src);
        return;
      }

      const proxyUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(src)}`;
      try {
        const response = await fetch(proxyUrl);
        if (!response.ok) throw new Error('Network response was not ok');
        const blob = await response.blob();
        if (!isCancelled) setImageUrl(URL.createObjectURL(blob));
      } catch (error) {
        if (!isCancelled) setHasError(true);
      }
    };

    fetchImage();

    return () => {
      isCancelled = true;
      if (imageUrl && !imageUrl.startsWith('/') && !imageUrl.startsWith('data:image')) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [src]);

  if (hasError) {
    if (config.welcomeStyle === 'minimal') {
      return (
        <div
          className={`${sizeClass} rounded-full overflow-hidden mx-auto ${config.photoBorderClass || 'border-4'} ${config.fetchedImageBorder} shadow-lg flex items-center justify-center`}
          style={{ background: `linear-gradient(to bottom right, ${config.fetchedImageFallbackFrom}, ${config.fetchedImageFallbackTo})` }}
        >
          <span className="text-3xl font-bold text-white">{config.initials}</span>
        </div>
      );
    }

    return (
      <div className={`${sizeClass} rounded-full mx-auto ${config.photoBorderClass || 'border-4'} ${config.fetchedImageBorder} shadow-md flex items-center justify-center ${config.rightPaneBg || 'bg-gray-100'}`}>
        <UserCircleIcon className={iconSizeClass} style={{ color: config.fetchedImageFallbackIcon || '#CBD5E1' }} />
      </div>
    );
  }

  if (!imageUrl) {
    return <div className={`${sizeClass} rounded-full mx-auto ${config.photoBorderClass || 'border-4'} ${config.fetchedImageBorder} shadow-md bg-gray-200 animate-pulse`} />;
  }

  if (hasCustomPhotoRing) {
    return (
      <div
        className={`${sizeClass} rounded-full mx-auto p-[4px]`}
        style={{ background: `linear-gradient(135deg, ${photoRingOuterStart}, ${photoRingOuterEnd})`, boxShadow: `0 14px 30px ${photoRingShadow}` }}
      >
        <div className="w-full h-full rounded-full p-[3px] overflow-hidden" style={{ backgroundColor: photoRingInner }}>
          <img src={imageUrl} alt={alt} className={`w-full h-full object-cover ${config.photoObjectClass || ''}`} style={photoImageStyle} />
        </div>
      </div>
    );
  }

  if (typeof config.photoZoom === 'number') {
    return (
      <div className={`${sizeClass} rounded-full overflow-hidden mx-auto ${config.photoBorderClass || 'border-4'} ${config.fetchedImageBorder} shadow-md`}>
        <img
          src={imageUrl}
          alt={alt}
          className={`w-full h-full object-cover ${config.photoObjectClass || ''}`}
          style={photoImageStyle}
        />
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={`${sizeClass} rounded-full object-cover ${config.photoObjectClass || ''} mx-auto ${config.photoBorderClass || 'border-4'} ${config.fetchedImageBorder} shadow-md`}
      style={photoImageStyle}
    />
  );
};

const MinimalWelcomeScreen = ({ config, onStart }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-8 py-12">
        <FetchedImage src={config.photoUrl} alt={config.name} config={config} />

        <h1 className="text-2xl font-bold text-gray-900 text-center">{config.name}</h1>
        <p className="font-medium mt-1" style={{ color: config.accentColor }}>
          {config.clinic}
        </p>
        <p className="text-gray-500 text-sm mt-2 text-center max-w-xs">{config.address}</p>

        <div className="w-16 h-0.5 bg-gray-200 my-8" />

        <h2 className="text-xl font-semibold text-gray-900 text-center mb-2">AI Skin Analysis</h2>
        <p className="text-gray-500 text-center text-sm max-w-xs mb-8">Get a personalized skin assessment and detailed PDF report in just 3 minutes</p>

        <div className="flex items-center justify-center gap-6 mb-10">
          <div className="text-center">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-2 mx-auto" style={{ backgroundColor: `${config.accentColor}1A` }}>
              <svg className="w-5 h-5" style={{ color: config.accentColor }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <p className="text-xs text-gray-600">Photo</p>
          </div>

          <div className="text-gray-300">→</div>

          <div className="text-center">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-2 mx-auto" style={{ backgroundColor: `${config.accentColor}1A` }}>
              <svg className="w-5 h-5" style={{ color: config.accentColor }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <p className="text-xs text-gray-600">Analyze</p>
          </div>

          <div className="text-gray-300">→</div>

          <div className="text-center">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-2 mx-auto" style={{ backgroundColor: `${config.accentColor}1A` }}>
              <svg className="w-5 h-5" style={{ color: config.accentColor }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <p className="text-xs text-gray-600">Report</p>
          </div>
        </div>

        <button
          onClick={onStart}
          className="w-full max-w-xs text-white py-4 rounded-2xl font-semibold text-lg active:scale-[0.98] transition-transform"
          style={{ backgroundColor: config.accentColor, boxShadow: `0 10px 20px ${config.accentColor}4D` }}
        >
          Start Analysis
        </button>
      </div>

      <div className="border-t border-gray-100 px-6 py-4">
        <div className="flex justify-center gap-4">
          <a href={`tel:${config.phone}`} className="flex items-center gap-2 text-gray-600 text-sm">
            <PhoneIcon className="w-4 h-4" />
            Call
          </a>
          <span className="text-gray-300">|</span>
          {config.contactType === 'booking' ? (
            <a href={config.bookingUrl || '#'} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-600 text-sm">
              <CalendarIcon className="w-4 h-4" />
              Booking
            </a>
          ) : (
            <a href={config.whatsappUrl || '#'} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-600 text-sm">
              <WhatsAppIcon className="w-4 h-4" />
              WhatsApp
            </a>
          )}
          <span className="text-gray-300">|</span>
          <a href={config.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-600 text-sm">
            <MapPinIcon className="w-4 h-4" />
            Map
          </a>
        </div>
      </div>
    </div>
  );
};

const BranchCard = ({ branch, isActive, onClick, config }) => (
  <button
    onClick={onClick}
    className={`flex-1 min-w-[100px] px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-300 border-2 ${
      isActive ? 'text-white border-transparent shadow-lg' : 'bg-white text-gray-700 hover:shadow-sm'
    }`}
    style={
      isActive
        ? { background: `linear-gradient(to right, ${config.accentColor}, ${config.accentColorDark})` }
        : { borderColor: `${config.accentColor}40`, backgroundColor: `${config.accentColor}08` }
    }
  >
    <div className="flex items-center justify-center gap-2">
      <MapPinIcon className="w-4 h-4" />
      <span>{branch.name}</span>
      {branch.isMain ? <span className={`text-xs px-1.5 py-0.5 rounded ${isActive ? 'bg-white/20' : ''}`} style={!isActive ? { backgroundColor: `${config.accentColor}26`, color: config.contactLinkText ? undefined : '#6B7280' } : undefined}>HQ</span> : null}
    </div>
  </button>
);

const SplitPaneWelcomeScreen = ({ config, onStart }) => {
  const [selectedBranch, setSelectedBranch] = useState(config.branches?.[0] || null);
  const welcomeCardStyle =
    config.welcomeCardBorderColor || config.welcomeCardShadow
      ? {
          border: config.welcomeCardBorderColor ? `1px solid ${config.welcomeCardBorderColor}` : undefined,
          boxShadow: config.welcomeCardShadow || undefined
        }
      : undefined;

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-white">
      <div className="hidden md:flex md:w-5/12 lg:w-4/12 flex-col justify-center p-12 text-white relative" style={{ background: `linear-gradient(to bottom right, ${config.accentColor}, ${config.accentColorDark})` }}>
        {config.branches ? (
          <>
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" />
          </>
        ) : null}

        <h2 className="text-4xl lg:text-5xl font-bold leading-tight tracking-tight relative z-10">Advanced AI Skin Analysis</h2>
        <p className={`mt-4 text-lg opacity-90 relative z-10 ${config.leftPaneSubtitleColor || ''}`}>Welcome to the digital consultation portal for {config.branches ? config.clinic : `the ${config.clinic}`.replace('the the', 'the')}.</p>

        {config.branches ? (
          <div className="mt-8 relative z-10">
            <div className="flex items-center gap-2 mb-3">
              <BuildingIcon className={`w-5 h-5 ${config.leftPaneSubtitleColor || ''}`} />
              <span className={`${config.leftPaneSubtitleColor || ''} font-medium`}>Our Locations</span>
            </div>
            <div className="flex flex-wrap gap-2">
              {config.branches.map((branch, idx) => (
                <span key={idx} className="bg-white/20 px-3 py-1.5 rounded-full text-sm">
                  {branch.name}
                </span>
              ))}
            </div>
          </div>
        ) : null}
      </div>

      <div className={`w-full md:w-7/12 lg:w-8/12 flex items-center justify-center p-4 sm:p-8 ${config.rightPaneBg || 'bg-white'}`}>
        <div className="max-w-2xl w-full bg-white rounded-3xl shadow-lg overflow-hidden my-8" style={welcomeCardStyle}>
          {config.welcomeCardAccent ? (
            <div className="h-1.5 w-full" style={{ background: `linear-gradient(90deg, ${config.accentColor}, ${config.accentColorDark || config.accentColor})` }} />
          ) : null}
          <div className="p-8 text-center border-b border-gray-200">
            <FetchedImage src={config.photoUrl} alt={config.name} config={config} />
            <h1 className="text-3xl font-bold tracking-tight text-gray-800">{config.name}</h1>
            <p className={`text-md mt-1 font-medium ${config.clinicNameColor || ''}`}>{config.clinic}</p>

            {config.branches ? (
              <>
                <div className="mt-6">
                  <p className="text-gray-500 text-xs mb-3 uppercase tracking-wider font-medium">Select a Branch</p>
                  <div className="flex flex-wrap justify-center gap-2">
                    {config.branches.map((branch, idx) => (
                      <BranchCard key={idx} branch={branch} isActive={selectedBranch?.name === branch.name} onClick={() => setSelectedBranch(branch)} config={config} />
                    ))}
                  </div>
                </div>

                <div className="mt-4 p-3 rounded-xl" style={{ backgroundColor: `${config.accentColor}10` }}>
                  <p className="text-gray-600 text-sm flex items-center justify-center gap-2">
                    <MapPinIcon className="w-4 h-4" style={{ color: config.accentColor }} />
                    {selectedBranch?.address}
                  </p>
                  <a href={selectedBranch?.mapsUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 mt-2 text-sm font-medium transition-colors" style={{ color: config.contactLinkText ? undefined : config.accentColor }}>
                    <span>View on Maps</span>
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
              </>
            ) : (
              <p className={`text-gray-500 text-sm mt-3 flex ${config.photoSize === 'large' ? 'items-start' : 'items-center'} justify-center gap-2`}>
                <MapPinIcon className={`w-4 h-4 text-gray-400 ${config.photoSize === 'large' ? 'flex-shrink-0 mt-0.5' : ''}`} />
                {config.address}
              </p>
            )}
          </div>

          <div className="p-8 md:p-10">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-3">Begin Your Personalised Consultation</h2>
              <p className="text-gray-600 max-w-2xl mx-auto">In three simple steps, our AI will analyze your skin and generate a personalized preliminary report for your consultation.</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
              <FeatureCard icon={<CameraIcon color={config.accentColor} />} title="1. Snap Photo" description="Capture a clear photo of the skin area." config={config} />
              <FeatureCard icon={<SparklesIcon color={config.accentColor} />} title="2. AI Analysis" description="Our system analyzes the image instantly." config={config} />
              <FeatureCard icon={<DocumentTextIcon color={config.accentColor} />} title="3. Get Report" description="Receive a detailed report for the doctor." config={config} />
            </div>

            <div className="text-center">
              <button
                onClick={onStart}
                className="w-full sm:w-auto text-white px-10 py-4 rounded-xl text-lg font-semibold transition-all duration-300 ease-in-out shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                style={{ background: `linear-gradient(to right, ${config.accentColor}, ${config.accentColorDark})` }}
              >
                Start My Skin Analysis
              </button>
            </div>

            <div className="mt-10 pt-6 border-t border-gray-200 text-center">
              <p className="text-gray-500 text-xs mb-4">For appointments or questions, contact the clinic:</p>
              <div className="flex flex-wrap justify-center items-center gap-3">
                <ContactLink href={`tel:${config.phone.replace(/\s/g, '')}`} text="Call Clinic" icon={<PhoneIcon className="w-4 h-4" />} config={config} />
                {config.contactType === 'booking' ? (
                  <ContactLink href={config.bookingUrl} text="Book an Appointment" icon={<CalendarIcon className="w-4 h-4" />} config={config} />
                ) : (
                  <ContactLink href={config.whatsappUrl} text="WhatsApp" icon={<WhatsAppIcon className="w-4 h-4" />} config={config} />
                )}
                {!config.branches ? <ContactLink href={config.mapsUrl} text="Directions" icon={<MapPinIcon className="w-4 h-4" />} config={config} /> : null}
              </div>

              {config.branches ? (
                <div className="mt-6 pt-4 border-t border-gray-100">
                  <p className="text-gray-500 text-xs mb-3 text-center uppercase tracking-wider">Get Directions to Our Branches</p>
                  <div className="flex flex-wrap justify-center gap-2">
                    {config.branches.map((branch, idx) => (
                      <a
                        key={idx}
                        href={branch.mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg transition-colors"
                        style={{ backgroundColor: `${config.accentColor}10`, color: config.contactLinkText ? undefined : config.accentColor }}
                      >
                        <MapPinIcon className="w-3.5 h-3.5" />
                        {branch.name}
                      </a>
                    ))}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FeatureCard = ({ icon, title, description, config }) => (
  <div className="text-center p-2">
    <div className={`w-16 h-16 ${config.featureCardIconBg || ''} rounded-full mx-auto mb-4 flex items-center justify-center`}>{icon}</div>
    <h3 className="font-bold text-gray-800 text-md mb-1">{title}</h3>
    <p className="text-sm text-gray-600 leading-tight">{description}</p>
  </div>
);

const ContactLink = ({ href, text, icon, config }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex items-center justify-center gap-2 text-sm font-semibold rounded-full px-5 py-2.5 transition-all duration-300 hover:shadow-md transform hover:-translate-y-0.5 ${config.contactLinkText || ''} ${config.contactLinkBg || ''} ${config.contactLinkBorder || ''} border`}
  >
    {icon}
    <span>{text}</span>
  </a>
);

export default UnifiedDoctorPage;
